export function formatDisplayScore(displayScore: number, scoreType: string) {
  let formattedScore
  if (scoreType === "T") {
    formattedScore = displayScore.toFixed(1)
  } else {
    formattedScore = displayScore < 10 ? `0${displayScore}` : displayScore
  }
  return formattedScore
}
